import { FC } from "react";
import CustomLink from "@Components/CustomLink";
import { WhitelabelMenuItemProps } from "./types";
import classes from "./mobileheader.module.scss";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

const WhitelabelMenuItem: FC<WhitelabelMenuItemProps> = ({ label, icon, redirectTo, rightIcon }) =>
  redirectTo ? (
    <CustomLink
      href={redirectTo}
      target="_blank"
      rel="noopener noreferrer"
      isExternal
      className={formatClassNames(classes.option)}
    >
      <div className={classes.optionLabel}>
        {icon && <>{icon}</>}
        <div className={classes.label}>{label}</div>
      </div>
      {rightIcon && <>{rightIcon}</>}
    </CustomLink>
  ) : (
    <div className={formatClassNames(classes.option)}>
      <div className={classes.optionLabel}>
        {icon && <>{icon}</>}
        <div className={classes.label}>{label}</div>
      </div>
      {rightIcon && <>{rightIcon}</>}
    </div>
  );

export default WhitelabelMenuItem;
